export const loginURL = {
  beta: 'https://www.dev.ring.com/users/sign_in',
  gamma: 'https://www.qa.ring.com/users/sign_in',
  prod: 'https://ring.com/users/sign_in',
};

export const logoutURL = {
  beta: 'https://www.dev.ring.com/users/sign_out',
  gamma: 'https://www.qa.ring.com/users/sign_out',
  prod: 'https://ring.com/users/sign_out',
};

export const homeURL = {
  beta: 'https://www.dev.ring.com',
  gamma: 'https://www.qa.ring.com',
  prod: 'https://ring.com',
};

export const ringDashboardURL = {
  beta: 'https://account.dev.ring.com/account/dashboard',
  gamma: 'https://account.qa.ring.com/account/dashboard',
  prod: 'https://account.ring.com/account/dashboard',
};

export const controlCenterApiUrl = {
  beta: 'https://controlcenter.vsg.dev.ring.com',
  gamma: 'https://controlcenter.vsg.qa.ring.com',
  prod: 'https://controlcenter.vsg.ring.com',
};

export const localUrls = {
  beta: 'https://controlcenter.local.vsg.dev.ring.com',
  gamma: 'https://controlcenter.local.vsg.qa.ring.com',
};

export const ringMobileDashboardURL = 'ring://main-dashboard';

export const LINKED_ACCOUNTS_URL = 'https://account.ring.com/account/control-center/linked-accounts';
export const GENERAL_INFORMATION_URL = 'https://support.ring.com/hc/en-us/articles/4405531453844';
export const HOW_TO_USE_GEOFENCE_URL = 'https://support.ring.com/hc/en-us/articles/360052805372-How-to-Use-Geofence-in-the-Ring-App';
export const OVERAGES_EDUCATION_ARTICLE_URL = 'https://support.ring.com/hc/en-us/articles/10427638019092-Extra-Events-for-Virtual-Security-Guard';
export const HOW_TO_USE_MOTION_ZONES_URL =
  'https://support.ring.com/hc/en-us/articles/360021842611-Utilizing-Motion-Zones-With-Your-Video-Doorbells-and-Security-Cameras';
export const CREATING_PRIVACY_ZONES_URL = 'https://support.ring.com/hc/en-us/articles/360028035532-Creating-Privacy-Zones';
export const REQUIREMENTS_FOR_VIRTUAL_SECURITY_GUARD_URL =
  'https://support.ring.com/hc/en-us/articles/4405531453844-Requirements-for-Virtual-Security-Guard';
export const VIDEO_URL = 'https://www.youtube.com/watch?v=vugEK7LKhnM';
export const FREE_TRIAL_TERMS_URL = 'https://ring.com/promotional-terms-and-conditions#VSGtrial';
export const TERMS_URL = 'https://ring.com/terms';
export const RING_WEB_URL = 'https://ring.com';
export const RR_TERMS_URL = 'https://vsg.rrms.com/terms-conditions';
export const RR_PRIVACY_NOTICE_URL = 'https://vsg.rrms.com/privacy-policy/';
export const PRIVACY_NOTICE_URL = 'https://ring.com/privacy-notice';
export const HOW_VSG_WORKS_URL = 'https://support.ring.com/hc/en-us/articles/4405525067412-How-Virtual-Security-Guard-Works';
export const SETTINGS_GEOFENCE_URL = 'https://ring.com/app/s/settings/geofence';
export const BILLING_PLANS_URL = 'https://account.ring.com/account/billing/plans';
